<template>
	<div class="flex flex-col w-full">
		<h1 class="flex text-2xl !font-semibold">
			{{ props.category }}
		</h1>
		<div class="flex flex-col justify-center gap-1">
			<div
				v-for="option in props.options"
				:key="option"
				class="flex items-center gap-2"
			>
				<Checkbox
					v-model="selectedFilterOption"
					:name="option"
					:value="option"
					@change="updateFilterSelection"
				/>
				<label for="ingredient1">{{ option }}</label>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import type {
		IWishListFilter
	} from "~/types/registry";

	const props = defineProps<IWishListFilter>();
	const filterSelection = defineModel<IWishListFilter[]>( "filterSelection", { required: true } );
	const emit = defineEmits( [ "filterWishlist" ] );
	const selectedFilterOption = ref<string[]>( [] );

	const updateFilterSelection = () => {
		filterSelection.value.forEach( ( filterOption: IWishListFilter ) => {
			if ( filterOption.category === props.category ) {
				filterOption.options = selectedFilterOption.value;
			}
		} );
		emit( "filterWishlist" );
	};
</script>

<style scoped>

</style>